'use es6';

import { createSelector } from 'reselect';
import ContentRoutes from 'ContentUtils/Routes';
import StateStatusGroups from 'ContentUtils/constants/StateStatusGroups';
import { getHasStagingDomain } from 'ContentEditorUI/redux/selectors/contentSchemaSelectors';
import { getIsStagingV2 } from 'ContentEditorUI/redux/selectors/authSelectors';
import { getContentState, getSubcategory, getContentModelId, getPreviewKey } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getCategoryId, getContentGroupId, getIsBlogListingPage } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import { getScopes } from 'ContentEditorUI/redux/selectors/authSelectors';
import { getPageSettingsFullUrl } from 'page-editor-ui/redux/selectors/pageSettingsSelectors';
import { basicSelectorWithStats } from 'ContentEditorUI/redux/selectors/helpers';
import { buildSandboxUrl } from 'page-editor-ui/utils/urlUtils';
const getReturnToDashboardUrl = createSelector([getCategoryId, getSubcategory, getContentGroupId, getIsBlogListingPage, getScopes], (categoryId, subcategory, contentGroupId, isBlogListingPage, scopes) => ContentRoutes.dashboard(categoryId, subcategory, isBlogListingPage ? contentGroupId : null, scopes));

// Note, email's getIsDraft selector is a little different (it excludes `ERROR`)
const getIsDraft = createSelector([getContentState], state => StateStatusGroups.DRAFT.includes(state));
const getStagingDashboardUrl = state => {
  if (getIsStagingV2(state)) {
    return ContentRoutes.staging();
  }
  const route = getIsDraft(state) ? '/manage/stagedDraft' : '/review';
  const domainId = state.contentSchema.context.secondary_to_domain && state.contentSchema.context.secondary_to_domain.id;

  // Staging beta is gone, no need to check its gate anymore (I believe?)
  return ContentRoutes.staging(domainId, route);
};
export const getDashboardUrl = basicSelectorWithStats(state => {
  if (getHasStagingDomain(state) || getIsStagingV2(state)) {
    return getStagingDashboardUrl(state);
  }
  return getReturnToDashboardUrl(state);
});
export const getStagedPageDomainName = state => state.stagedPage && state.stagedPage.domainName;
const getStagedPageStatus = state => state.stagedPage && state.stagedPage.status;
const getStagedPagePreviewUrl = state => state.stagedPage && state.stagedPage.previewUrl;
export const getPublishedOrStagingUrl = createSelector([getPageSettingsFullUrl, getIsStagingV2, getStagedPageDomainName, getStagedPageStatus], (publishedURL, isStagingV2, stagedDomain, stagedStatus) => {
  if (isStagingV2 && stagedStatus === 'PROOF' && stagedDomain) {
    return buildSandboxUrl(stagedDomain, publishedURL);
  }
  return publishedURL;
});
export const getShareablePreviewUrl = createSelector([getContentModelId, getPreviewKey, getPageSettingsFullUrl, getIsStagingV2, getStagedPagePreviewUrl], (id, previewKey, publishedURL, isStagingV2, stagedPreviewUrl) => {
  if (isStagingV2 && stagedPreviewUrl) {
    return stagedPreviewUrl;
  }
  return `${publishedURL}?hs_preview=${previewKey}-${id}`;
});